import { MenuItem } from 'react-bootstrap';
import classNames from 'classnames';
import React from 'react';

const CustomSelectMenuItem = (comboboxProps, isActive, isDisabled) => {
  const { item, getItemProps, index } = comboboxProps;
  const { id, archived } = item;

  const active = isActive(item);
  const disabled = isDisabled ? !isActive(item) && !!isDisabled(id) : false;
  return (
    <MenuItem
      className={classNames({ disabled, active })}
      key={item.id}
      {...getItemProps({
        index,
      })}
    >
      <span className={archived && !active ? 'text-muted' : ''}>
        {archived ? `${item.fullName} (archived)` : item.fullName}
      </span>
    </MenuItem>
  );
};

export default CustomSelectMenuItem;
